import { BaseObject, IBaseObject } from './BaseObject';
import { AssociationSegment, IAssociationSegment } from './AssociationSegment';
import { ISagtFeature } from './SagtFeature';

export interface IPgmResponseFromSegmentTypeEs {
  id: number;
  idPgm: number;
  descriptionPgm: string;
  idSegment: number;
  nomSegment: string;
  idTypeEs: number;
  descriptionTypeEs: string;
}

export interface IPlanGestionMobilite extends IBaseObject {
  description: string;
  commentaire: string | undefined;
  idMode: number | undefined;
  descriptionMode?: string;
  idEtatDetaille: number | undefined;
  descriptionEtatDetaille?: string;
  features?: ISagtFeature[] | null;
  associations: IAssociationSegment[] | null;
  /**
   * should be 5 digit
   */
  numero: string;
  lstUrlCreationPgm: Array<{ nomSousSysteme: string; urlCreationPgm: string }>;
  idHisto: number;
}

export class PlanGestionMobilite extends BaseObject implements IPlanGestionMobilite {
  description = '';
  commentaire: string | undefined;
  associations: AssociationSegment[] = [];
  features: ISagtFeature[] = [];
  idEtatDetaille: number | undefined;
  descriptionEtatDetaille?: string;
  idMode: number | undefined;
  descriptionMode?: string;
  numero!: string;
  lstUrlCreationPgm: Array<{ nomSousSysteme: string; urlCreationPgm: string }> = [];
  idHisto!: number;

  constructor(props?: IPlanGestionMobilite) {
    super(props);

    if (props) {
      if (props.associations) {
        this.associations = props.associations.map((x) => new AssociationSegment(x));
      }
      if (props.features) {
        this.features = props.features.map((x) => Object.assign({}, x));
      }
      this.description = props.description;
      this.commentaire = props.commentaire;
      this.idEtatDetaille = props.idEtatDetaille;
      this.descriptionEtatDetaille = props.descriptionEtatDetaille;
      this.idMode = props.idMode;
      this.descriptionMode = props.descriptionMode;
      this.numero = props.numero;
      this.lstUrlCreationPgm = props.lstUrlCreationPgm;
      this.idHisto = props.idHisto;
    }
  }

  public format(): IPlanGestionMobilite {
    const item: IPlanGestionMobilite = {
      id: this.id,
      associations: this.associations.map((x) => x.format()),
      idMode: this.idMode,
      commentaire: this.commentaire,
      description: this.description,
      idEtatDetaille: this.idEtatDetaille,
      numero: this.numero,
      lstUrlCreationPgm: this.lstUrlCreationPgm,
      idHisto: this.idHisto,
    };

    if (item.id == null || item.id === -1) {
      // @ts-ignore
      delete item.id;
    }

    return item;
  }
}
